import { StyleSheet } from 'react-native';
import type { CardFrame } from './GameResultModal.constants';

const CARD_BG = '#13101F';

export const getGameResultSlideStyles = (frame: CardFrame, cardWidth: number) =>
  StyleSheet.create({
    containerFlex: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
    },
    containerCentered: {
      alignItems: 'center',
      justifyContent: 'center',
    },
    stageGlowWrap: {
      alignItems: 'center',
      justifyContent: 'center',
    },
    stageGlowCircle: {
      width: cardWidth + 100,
      height: cardWidth + 100,
      borderRadius: (cardWidth + 100) / 2,
      backgroundColor: frame.stageGlow,
    },
    cardWrap: {
      width: cardWidth,
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 28 },
      shadowOpacity: 0.60,
      shadowRadius: 36,
      elevation: 24,
    },
    holoStrip: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      zIndex: 3,
      width: cardWidth * 0.55,
    },
    cardFrame: {
      borderRadius: 22,
      padding: 7,
    },
    cardInnerBorder: {
      borderRadius: 16,
      padding: 3,
      backgroundColor: frame.innerBorderBg,
    },
    cardBody: {
      borderRadius: 13,
      overflow: 'hidden',
      backgroundColor: CARD_BG,
    },
    titlePlate: {
      paddingTop: 11,
      paddingBottom: 9,
      paddingHorizontal: 16,
      borderBottomWidth: 2,
      borderBottomColor: frame.innerBorderBg,
      alignItems: 'center',
      justifyContent: 'center',
    },
    cardTitle: {
      fontSize: 22,
      fontWeight: '900',
      letterSpacing: 3,
      textTransform: 'uppercase',
      textAlign: 'center',
      color: frame.plateText,
    },
    portrait: {
      height: 170,
      margin: 10,
      marginBottom: 4,
      borderRadius: 8,
      backgroundColor: '#1A1230',
      borderWidth: 1,
      borderColor: `${frame.frame}44`,
      overflow: 'hidden',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
    },
    portraitAvatar: {
      width: 122,
      height: 122,
      borderRadius: 61,
    },
    cornerStar: {
      position: 'absolute',
      fontSize: 10,
      color: frame.frame,
    },
    cornerTL: { top: 6, left: 8 },
    cornerTR: { top: 6, right: 8 },
    cornerBL: { bottom: 6, left: 8 },
    cornerBR: { bottom: 6, right: 8 },
    homeLabel: {
      position: 'absolute',
      bottom: 6,
      left: 0,
      right: 0,
      textAlign: 'center',
      fontSize: 7,
      fontWeight: '800',
      letterSpacing: 2,
      textTransform: 'uppercase',
      color: frame.frame,
    },
    rivalCircle: {
      position: 'absolute',
      bottom: 22,
      right: 20,
      width: 50,
      height: 50,
      borderRadius: 25,
      borderWidth: 2,
      overflow: 'hidden',
      alignItems: 'center',
      justifyContent: 'center',
      borderColor: `${frame.frame}99`,
      backgroundColor: '#0F0A1A',
    },
    rivalAvatar: {
      width: 46,
      height: 46,
      borderRadius: 23,
    },
    vsLabel: {
      position: 'absolute',
      bottom: 9,
      right: 20,
      fontSize: 7,
      fontWeight: '800',
      letterSpacing: 1.5,
      textTransform: 'uppercase',
      color: frame.frame,
    },
    cardSubtitle: {
      textAlign: 'center',
      fontSize: 11,
      fontWeight: '500',
      color: 'rgba(255,255,255,0.65)',
      paddingVertical: 6,
      paddingHorizontal: 16,
    },
    statsSection: {
      paddingHorizontal: 16,
      paddingBottom: 12,
      gap: 10,
    },
    payoutChip: {
      marginHorizontal: 16,
      marginBottom: 12,
      borderWidth: 1,
      borderRadius: 10,
      paddingVertical: 10,
      paddingHorizontal: 14,
      backgroundColor: 'rgba(255,255,255,0.04)',
      alignItems: 'center',
      gap: 4,
      borderColor: `${frame.frame}55`,
    },
    payoutLabel: {
      fontSize: 9,
      fontWeight: '700',
      letterSpacing: 3,
      color: '#9CA3AF',
      textTransform: 'uppercase',
    },
    payoutRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
    },
    coinIcon: {
      width: 34,
      height: 34,
    },
    payoutAmount: {
      fontSize: 30,
      fontWeight: '900',
      letterSpacing: -0.5,
      lineHeight: 34,
      color: frame.coinColor,
    },
    cardFooter: {
      backgroundColor: '#0A0612',
      borderTopWidth: 1,
      paddingVertical: 7,
      paddingHorizontal: 14,
      flexDirection: 'row',
      justifyContent: 'space-between',
      borderTopColor: `${frame.frame}33`,
    },
    footerText: {
      fontSize: 9,
      fontWeight: '700',
      letterSpacing: 2,
      color: '#6B7280',
      textTransform: 'uppercase',
    },
  });
